export default __webpack_public_path__ + "static/media/planet.da58bf36.svg";